import React from 'react';
import { FaMagic, FaChevronRight } from 'react-icons/fa';

const TryoutCTA = ({ onViewTryout, className = '' }) => {
  return (
    <div className={`w-full max-w-2xl mx-auto animate-slide-up ${className}`} style={{ animationDelay: '0.15s' }}>
      <button
        onClick={onViewTryout}
        className="group w-full flex items-center justify-between gap-4 bg-white/95 backdrop-blur-sm border border-primary-200 rounded-2xl p-5 shadow-elevated hover:shadow-glow-primary hover:border-primary-300 transition-all"
      >
        <div className="flex items-center gap-4 text-left">
          <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br from-primary-500 to-accent-500 flex items-center justify-center">
            <FaMagic className="text-white text-xl" />
          </div>
          <div>
            <div className="font-bold text-neutral-800 text-lg">Try a sample preview — free, no signup</div>
            <div className="text-sm text-neutral-500">See real attractions, photos, and a Day-1 plan for any destination.</div>
          </div>
        </div>
        <FaChevronRight className="text-primary-500 group-hover:translate-x-1 transition-transform flex-shrink-0" />
      </button>
    </div>
  );
};

export default TryoutCTA;
